import { render, staticRenderFns } from "./OrderMenu.vue?vue&type=template&id=6ea52217"
import script from "./OrderMenu.vue?vue&type=script&lang=ts"
export * from "./OrderMenu.vue?vue&type=script&lang=ts"
import style0 from "./OrderMenu.vue?vue&type=style&index=0&id=6ea52217&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports